import { render, staticRenderFns } from "./PagoEfectivoForm.vue?vue&type=template&id=5b60693a&scoped=true"
import script from "./PagoEfectivoForm.vue?vue&type=script&lang=js"
export * from "./PagoEfectivoForm.vue?vue&type=script&lang=js"
import style0 from "./PagoEfectivoForm.vue?vue&type=style&index=0&id=5b60693a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b60693a",
  null
  
)

export default component.exports